<template>
  <div>
    <section>
      <h1 class="is-size-5 has-margin-bottom-small">Biological attributes</h1>
      <div class="is-padded-small">
        <key-value-table :items="tableItems" />
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KeyValueTable from '@/components/structures/KeyValueTable'

export default {
  components: {
    KeyValueTable
  },
  computed: {
    ...mapGetters(['selectedAgent']),
    tableItems () {
      // eslint-disable-next-line
      const { formula, ld50, molecular_weight, structure, lel, uel, odor_threshold, lc50, acgih_8h, acgih_stel, idlh, proton_affinity, hazard_id } = this.selectedAgent
      return [
        { label: 'Formula', value: formula },
        { label: 'LD50', value: ld50 },
        { label: 'Molecular weight', value: molecular_weight, unit: 'g/mol' },
        { label: 'Structure', value: structure },
        { label: 'Lower Explosive Limit (LEL)', value: lel, unit: '%' },
        { label: 'Upper Explosive Limit (UEL)', value: uel, unit: '%' },
        { label: 'Odor threshold', value: odor_threshold, unit: 'ppm' },
        { label: 'LC50', value: lc50, unit: 'ppm' },
        { label: 'ACGIH 8h', value: acgih_8h, unit: 'ppm' },
        { label: 'ACGIH STEL', value: acgih_stel, unit: 'ppm' },
        { label: 'IDLH', value: idlh, unit: 'ppm' },
        { label: 'Proton Affinity', value: proton_affinity, unit: 'kJ/mole' },
        { label: 'Hazard ID Number', value: hazard_id },
      ]
    }
  }
}
</script>
